import { api } from "api/api";
import { UnidadeCicloFiscal, SerieCicloFiscal, ResumoFiscal, OperacaoFiscal, InutilizacaoFiscal, FaixaFiscal, ContingenciaFiscal, RequisitoFiscal, SolicitarInutilizacao, AtivarContingencia } from "model/fiscal/CicloFiscal";

const url="/fiscal/ciclo";
export default class CicloFiscalService {
    nomeAmbiente(ambiente: string | null | undefined): string {
        const nomes: Record<string, string> = {
            HOMOLOGACAO: "Homologação",
            PRODUCAO: "Produção"
        };
        return ambiente ? nomes[ambiente] ?? ambiente : "—";
    }

    nomeTipo(tipo: string | null | undefined): string {
        const nomes: Record<string, string> = {
            OPERACAO: "Operação",
            INTEGRACAO: "Integração",
            CERTIFICADO: "Certificado",
            AUTORIZACAO: "Autorização",
            CONSULTA_RECIBO: "Consulta de recibo",
            CONSULTA_PROTOCOLO: "Consulta de protocolo",
            EVENTO: "Evento",
            INUTILIZACAO: "Inutilização"
        };
        return tipo ? nomes[tipo] ?? tipo : "—";
    }

    nomeSituacao(situacao: string | null | undefined): string {
        const nomes: Record<string, string> = {
            PENDENTE: "Pendente",
            EXECUTANDO: "Em processamento",
            AGUARDANDO_RECIBO: "Aguardando recibo",
            INCERTA: "Incerta",
            MANUAL: "Intervenção manual",
            CONCLUIDA: "Concluída",
            REJEITADA: "Rejeitada",
            FALHA_LOCAL: "Falha local",
            DISPENSADA: "Dispensada",
            VENCIDO: "Vencido",
            VENCENDO: "Próximo do vencimento",
            INUTILIZADA: "Inutilizada",
            ATIVA: "Ativa",
            ENCERRADA: "Encerrada"
        };
        return situacao ? nomes[situacao] ?? situacao : "—";
    }

    unidades() {
        return api.get<UnidadeCicloFiscal[]>(`${url}/unidades`).then(r=>r.data);
    }

    series() {
        return api.get<SerieCicloFiscal[]>(`${url}/series`).then(r=>r.data);
    }

    resumo() {
        return api.get<ResumoFiscal[]>(`${url}/monitoramento`).then(r=>r.data);
    }

    operacoes() {
        return api.get<OperacaoFiscal[]>(`${url}/operacoes`).then(r=>r.data);
    }

    reconciliar(id:number) {
        return api.post<void>(`${url}/operacoes/${id}/reconciliar`);
    }

    inutilizacoes() {
        return api.get<InutilizacaoFiscal[]>(`${url}/inutilizacoes`).then(r=>r.data);
    }

    inutilizar(dto:SolicitarInutilizacao) {
        return api.post<InutilizacaoFiscal>(`${url}/inutilizacoes`,dto).then(r=>r.data);
    }

    lacunas(id:number) {
        return api.get<FaixaFiscal[]>(`${url}/series/${id}/lacunas`).then(r=>r.data);
    }

    xmlInutilizacao(id:number) {
        return api.get<Blob>(`${url}/inutilizacoes/${id}/xml`,{responseType:"blob"}).then(r=>r.data);
    }

    contingencias() {
        return api.get<ContingenciaFiscal[]>(`${url}/contingencias`).then(r=>r.data);
    }

    ativarContingencia(dto:AtivarContingencia) {
        return api.post<ContingenciaFiscal>(`${url}/contingencias`,dto);
    }

    encerrarContingencia(id:number) {
        return api.post<void>(`${url}/contingencias/${id}/encerrar`);
    }

    requisitos(id:number) {
        return api.get<RequisitoFiscal[]>(`${url}/unidades/${id}/requisitos`).then(r=>r.data);
    }

    ativar(id:number) {
        return api.post<void>(`${url}/unidades/${id}/ativar`);
    }

    pausar(id:number,pausada:boolean) {
        return api.post<void>(`${url}/unidades/${id}/pausa`,null,{params:{pausada}});
    }

}
